module.exports = "/assets/data/1443129bcf754b809b48836b61a50592-TN9.data.json";